<script setup lang="ts">
import { config } from '@/config';
import { Loader } from '@googlemaps/js-api-loader';
import { ref } from 'vue';
import Loading from '@/components/ui/Loading.vue';

const loaded = ref(false);

async function setup() {
  const loader = new Loader({
    apiKey: config.googleApiKey,
    version: 'weekly',
  });

  await loader.importLibrary('places');

  loaded.value = true;
}

setup();
</script>

<template>
  <slot v-if="loaded"> </slot>
  <Loading class="mx-auto mt-10 h-10 w-10" v-else />
</template>
